<template>
  <div class="col col-login mx-auto">
    <div class="text-center mb-6">
      <img src="../../assets/Goalpilot_logo_white_500.png" class="h-6" alt="">
    </div>
    <div v-if="error_code" class="alert alert-danger" role="alert">
      <strong>Error!</strong> {{error_message}}
    </div>
    <form class="card" @submit.prevent="signInWithEmailAndPassword">
      <div class="card-body p-6">
        <div class="card-title">Login to your account</div>
        <div class="form-group">
          <label class="form-label">Email address</label>
          <input v-model="userInput.userEmail" type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email" autocomplete="username">
        </div>
        <div class="form-group">
          <label class="form-label">
            Password
            <a href="#" @click.prevent="onForgotPassword" tabindex="1" class="float-right small">I forgot my password</a>
          </label>
          <input v-model="userInput.userPassword" type="password" class="form-control" id="exampleInputPassword1" placeholder="Password" autocomplete="current-password">
        </div>
        <div class="form-group">
          <label class="custom-control custom-checkbox">
            <input v-model="userInput.rememberMe" type="checkbox" class="custom-control-input">
            <span class="custom-control-label pl-0">Remember me</span>
          </label>
        </div>
        <div class="form-footer">
          <button type="submit" class="btn btn-primary btn-block">Sign in</button>
          <button @click.prevent="signInWithGoogle" class="btn btn-secondary btn-block">
            <i class="fa fa-google"></i>
            Sign in with Google
          </button>
          <button @click.prevent="signInWithFacebook" class="btn btn-secondary btn-block">
            <i class="fa fa-facebook"></i>
            Sign in with Facebook
          </button>
        </div>
      </div>
    </form>
    <div class="text-center text-muted">
      Don't have account yet? <a href="#" @click.prevent="onGotoRegister">Sign up</a>
    </div>
  </div>
</template>

<script>
//import "particles.js";
//import config from "./particles.json";

/* INFO: The official firebase login UI can be found here:
         https://github.com/firebase/firebaseui-web */

export default {
  data() {
    return {
      error_code: undefined,
      error_message: '',
      userInput: {
        userEmail: "",
        userPassword: "",
        rememberMe: true
      }
    };
  },
  mounted() {
    /*window.particlesJS("particles-js", config, function() {
      console.log("callback - particles.js config loaded");
    });*/
  },
  methods: {

    signInWithGoogle() {
      // this.$emit("user-login", this.userInput);
      /*
      if (this.$store.state.loggedIn) {
        return;
      }
      */
      // this.$router.push('/today/goals') // HACK! So we get redirected to this page after login

      this.$api.auth_login_with_provider({
        providerName: "google",
        rememberMe: this.userInput.rememberMe
      })
      .then(this.onLoginResponseAuthProvider)
      // .catch(this.onLoginFailure);
    },
    signInWithFacebook() {
      // this.$emit("user-login", this.userInput);
      this.$api.auth_login_with_provider({
        providerName: "facebook",
        rememberMe: this.userInput.rememberMe
      })
      .then(this.onLoginResponseAuthProvider)
      // .catch(this.onLoginFailure);
    },
    signInWithEmailAndPassword() {
      // this.error_code = null;
      // this.error_message = '';

      // this.$emit("user-login", this.userInput);

      // TODO: Also pass in rememberMe here!
      this.$api.auth_login_with_email_and_password(this.userInput)
        .then(this.onLoginResponse)
        // .catch(this.onLoginFailure);
    },
    onLoginResponseAuthProvider( error ) {
      // Will this ever happen?
      if ( error && "code" in error ) {
        this.onLoginFailure(error)
      }
    },
    onLoginResponse( error ) {
      if ( error && "code" in error ) {
        this.onLoginFailure(error)
      } else {
        /* This will only work, when using password-email login not
           an auth provider */
        console.log("Sucessfully logged in ");
        this.$router.push(this.$route.query.redirect || "/"); // < this is not necessary, yet it is for normal login
      }
    },
    onLoginFailure(error) {
      console.log("Log in failed", error);
      this.error_code = error.code;
      this.error_message = error.message;
    },
    onGotoRegister() {
      // TODO: Router link
      this.$router.push("/register");
    },
    onForgotPassword() {
      // TODO: Router link
      this.$router.push("/forgot-password");
    }
  }
};
</script>

<style scoped>
/* ---- reset ---- */
body {
  margin: 0;
}

/*canvas {
  display: block;
  vertical-align: bottom;
}*/

</style>
